





































































import Vue from 'vue'
import DisabledTextInput from '@/UI/Shared/DisabledTextInput.vue'
import { ProcedureDto } from '@/Application/Procedures'

export default Vue.extend({
  name: 'ProcedureDetailForm',
  components: { DisabledTextInput },
  props: {
    procedure: {
      type: ProcedureDto,
      required: true
    },
    requiredTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data () {
    return {
      inputClasses: ['col-xs-12', 'col-sm-6', 'col-md-3'],
      placeInputClasses: ['col-xs-12', 'col-sm-6', 'col-md-6']
    }
  },
  computed: {
    isPoxa (): boolean {
      return this.procedure.procedureType === 'PX'
    }
  }
})
